const singleValueShapes = [
  'sha_round',
  'sha_square',
  'sha_square_round',
  //to be continued...
];

const singleValueMapping = {
  'sha_rectangle': 'sha_square',
  'sha_rectangle_round': 'sha_square_round',
  'sha_oval': 'sha_round',
};

// Inverse of singleValueMapping: maps square/round shapes back to their rectangle/oval counterpart.
// Used when a user enters different width/height on a square shape to switch back to rectangle.
const rectangleMapping = Object.fromEntries(
  Object.entries(singleValueMapping).map(([rect, single]) => [single, rect])
);

export const getSingleValueShape = (shape) => {
  if (singleValueMapping[shape]) {
    return singleValueMapping[shape];
  }

  return false;
};

export const isSingleValueShape = (shape) => {
  return singleValueShapes.includes(shape);
};

export const isDiameter = (shape) => {
  return shape === 'sha_round';
};

export const getRectangleShape = (shape) => {
  return rectangleMapping[shape] || false;
};

export const getCustomSizeType = (shape) => {
  switch (shape) {
    case 'sha_rectangle':
    case 'sha_rectangle_round':
      return 'regular';

    case 'sha_square':
    case 'sha_square_round':
      return 'square';

    case 'sha_oval':
      return 'oval';

    case 'sha_round':
      return 'round';

    default:
      return false;
  }
};
